export function selectEntityAction() {
  const { t } = useI18n();
  const viewerStore = useViewerStore();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.select') || 'Select',

    getEnabled: function (context) {
      return !context.entity.selected;
    },

    doAction: function (context) {
      context.entity.selected = true;
      const objectId = context.entity.id;
      viewerStore.showObjectProperties(objectId);
    },
  };
}
